import React, { useState } from 'react';
import { FaWhatsapp, FaPhone, FaFileInvoiceDollar, FaTimes, FaCommentDots } from 'react-icons/fa';
import '../../index.css'; // Find global styles

export const FloatingButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="cta-float-container">
            <div className={`cta-menu ${isOpen ? 'active' : ''}`}>
                <a href="https://wa.me/5493794223834" target="_blank" rel="noreferrer" className="cta-item whatsapp">
                    <span className="cta-label">WhatsApp</span> <FaWhatsapp />
                </a>
                <a href="tel:+5493794223834" className="cta-item phone">
                    <span className="cta-label">Llamada Directa</span> <FaPhone />
                </a>
                <a href="/contacto" className="cta-item budget">
                    <span className="cta-label">Pedir Presupuesto</span> <FaFileInvoiceDollar />
                </a>
            </div>

            <button className={`cta-main-btn ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)} aria-label="Abrir opciones de contacto">
                {isOpen ? <FaTimes /> : <FaCommentDots />}
            </button>
        </div>
    );
};
